import Preview from 'carbon-react/lib/components/preview';
import styled from 'styled-components';

const Root = styled.div`
  height: 100%;
  margin: auto;
  max-width: 1800px;
  padding: 32px 40px;
  width: 100%;
`;

const InnerPreview = styled.div`
  height: 100%;
`;

const Content = styled.div`
  margin-bottom: ${({ theme }) => theme.space[4]};
`;

const SourcesList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 850px;
  width: 100%;
`;

const PreviewComponent = () => {
  return (
    <Root>
      <InnerPreview>
        <Content>
          <SourcesList>
            <Preview height="222px" width="254px" loading />
            <Preview height="222px" width="254px" loading />
            <Preview height="222px" width="254px" loading />
          </SourcesList>
        </Content>
        <Preview height="322px" width="100%" loading />
      </InnerPreview>
    </Root>
  );
};

export default PreviewComponent;
